import { client } from "./index";

// payload: { orderId, productId, rating, text }
export const createReview = (payload) => client.post("/storefront/reviews", payload).then((res) => res.data.review);

export const getMyReviews = () => client.get("/storefront/reviews/mine").then((res) => res.data.reviews);

export const updateReview = (reviewId, payload) => client.put(`/storefront/reviews/${reviewId}`, payload).then((res) => res.data.review);

export const deleteReview = (reviewId) => client.delete(`/storefront/reviews/${reviewId}`).then((res) => res.data);
